<template>
  <div class="payroll__breakdown">
    <div class="payroll__breakdown--alert">
      <div class="payroll__breakdown--alert-icon">
        <img src="./../../../assets/images/checkbook.png" alt />
      </div>
      <div class="payroll__breakdown--alert-text">
        <span>Employee Earnings Breakdown</span>
        <p>
          <br />Your employees will be paid on your chosen payment date. To
          terminate this payroll before the due date, Kindly visit the
          <b>"Payroll History"</b>.
        </p>
      </div>
    </div>

    <div class="payroll__breakdown--loader" v-show="pageLoading">
      <div>
        <PageLoader />
      </div>
    </div>

    <div class="payroll__breakdown--details" v-show="!pageLoading">
      <div class="payroll__breakdown--details-header">
        <div class="payroll__breakdown--details-header-name">
          <div>Employee Name</div>
          <div>Gross Salary</div>
          <div>Net Pay</div>
        </div>
        <div class="payroll__breakdown--details-header-btn"></div>
      </div>
      <div
        class="payroll__breakdown--details-body"
        v-for="(emp, key) in employees"
        v-bind:key="emp.key"
      >
        <div :class="{ 'omitted-employee': isInOmittedList(emp.id) }">
          <div class="payroll__breakdown--details-body-header">
            <div class="payroll__breakdown--details-body-header-name">
              <div>{{ emp.fullname }}</div>
              <div>&#8358;{{ emp.grossPay | payrollValueToCurrency }}</div>
              <div>&#8358;{{ emp.netPay | payrollValueToCurrency }}</div>
            </div>
            <div class="payroll__breakdown--details-body-header-btn">
              <div
                v-if="!isInOmittedList(emp.id)"
                class="payroll__breakdown--details-body-header-skip"
                @click="skipEmployee(emp.id)"
              >
                - Skip Employee
              </div>

              <div
                v-if="isInOmittedList(emp.id)"
                class="payroll__breakdown--details-body-header-enable"
                @click="enableEmployee(emp.id)"
              >
                + Add Employee
              </div>
            </div>
          </div>
        </div>
      </div>

      <p class="breakdown-error" v-if="breakdownError">{{ breakdownError }}</p>
        <p class="breakdown-error" v-if="perviewError">{{ perviewError }}</p>
    </div>

    <div class="payroll__breakdown--btns" v-show="!pageLoading">
      <p>Don't worry, we aren't sending anything until the last step.</p>
    
      <div class="payroll__breakdown--btnscover">
        <button
        class="f_button"
          @click="saveRegularBreakdown"
          v-show="!btnLoading"
        >
          Save & Continue
        </button>
        <div class="payroll__breakdown--btns-load" v-show="btnLoading">
          <WhiteLoader />
        </div>
        <button class="cancel" @click="closeBreakdown">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
import WhiteLoader from "../../partials/white-loader";
import { payrollValueToCurrency } from "../../../util/filters";

export default {
  name: "BreakdownRegular",
  components: {
    PageLoader,
    WhiteLoader,
  },
  props: {
    omittedIds: {
      type: Array,
    },
  },
  data() {
    return {
      pageLoading: true,
      btnLoading: false,
      perviewError: false,
      employees: [],
      pageNumber: 0,
      omittedEmployeeIds: this.omittedIds,
      breakdownError: null,
    };
  },
  methods: {
    saveRegularBreakdown() {
      this.btnLoading = true;
      this.breakdownError = null;

      const regularPayrollData = {
        payroll_data: [],
      };

      let user = this.$store.getters.currentAuthUser;

      if (!this.$store.state.payrollMonth) {
        this.$router.push("/payroll/regular/initiate");
      }

      if (!this.$store.state.payrollYear) {
        this.$router.push("/payroll/regular/initiate");
      }

      regularPayrollData.company_id = user.employees.company_id;
      regularPayrollData.month = this.$store.state.payrollMonth;
      regularPayrollData.year = this.$store.state.payrollYear;
      regularPayrollData.title = this.$store.state.payrollTitle;
      regularPayrollData.day = parseInt(this.$store.state.payrollDay);

      let withoutExcluded = [];

      for (let i = 0; i < this.employees.length; i++) {
        const employee = this.employees[i];

        if (!this.omittedEmployeeIds.includes(employee.id)) {
          withoutExcluded.push(employee);
        }
      }

      if (withoutExcluded.length < 1) {
        this.breakdownError = "Payroll should contain atleast one employee.";

        this.btnLoading = false;

        return;
      }

      for (let employee of withoutExcluded) {
        let compensations = [];
        let deductibles = [];

        for (const comp of employee.components) {
          if (comp.type === "Compensation") {
            compensations.push({
              title: comp.name,
              amount: comp.value,
            });
          }
          if (comp.type === "Deductible") {
            deductibles.push({
              title: comp.name,
              amount: comp.value,
            });
          }
        }

        regularPayrollData.payroll_data.push({
          employee_id: employee.id,
          net_amount: employee.netPay,
          gross_amount: employee.grossPay,
          fullname: employee.fullname,
          components: {
            compensations,
            deductibles,
          },
        });
      }

      this.$store.state.omittedEmployeeIds = this.omittedEmployeeIds;
      this.perviewError = false;
      this.$http
        .post(types.PAYROLL_BREAKDOWN_POST_API, regularPayrollData)
        .then((resp) => {
          this.$store.state.summaryData = resp.data.data;
          this.$emit("clickedPreview");
        })
        .catch((error) => {

          let response = error.response;

          if (response.status === 400) {

            this.perviewError = response.data.message

          }
          
          this.btnLoading = false;
        });
    },
    closeBreakdown() {
      this.$router.push("/payroll/regular/initiate");
    },

    isInOmittedList(index) {
      return this.omittedEmployeeIds.includes(index);
    },
    skipEmployee(key) {
      this.omittedEmployeeIds.push(key);
    },
    enableEmployee(key) {
      const idx = this.omittedEmployeeIds.indexOf(key);
      if (idx !== -1) {
        this.omittedEmployeeIds.splice(idx, 1);
      }
    },
    getRegularBreakdownDetails() {
      this.pageLoading = true;
      this.$http
        .get(types.PAYROLL_BREAKDOWN_GET_API)
        .then((resp) => {
          const employeeData = resp.data.data.employees;

          for (let index = 0; index < employeeData.length; index++) {
            this.employees.push({
              id: employeeData[index].id,
              fullname:
                employeeData[index].user.firstname +
                " " +
                (employeeData[index].user.middlename
                  ? employeeData[index].user.middlename
                  : "") +
                " " +
                employeeData[index].user.lastname,
              grossPay: employeeData[index].gross_pay,
              netPay: employeeData[index].net_pay,
              components: employeeData[index].components,
            });
          }
          this.pageLoading = false;
        })
        .catch(() => {
          this.pageLoading = false;
        });
    },
  },
  created() {
    this.$emit("emitShowGoBack");
    this.getRegularBreakdownDetails();
  },
  filters: {
    payrollValueToCurrency,
  },
};
</script>


<style lang="scss" scoped>
.payroll__breakdown {
  margin-top: 20px;
  padding-top: 10px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;

  .omitted-employee {
    background: #edb7b7;
  }

  .breakdown-error {
    text-align: center;
    color: red;
  }

  > .payroll__breakdown--alert {
    overflow: hidden;

    > .payroll__breakdown--alert-icon {
      float: left;
      width: 3rem;

      @media (max-width: 768px) {
        width: 1.5rem;
        padding-left: 1rem;
      }
    }

    > .payroll__breakdown--alert-text {
      float: left;
      width: calc(100% - 4.271vw);
      padding: 0 10px;
      text-align: left;

      > span {
        font-size: 2rem;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.07;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      > p {
        font-size: 1rem;
        font-weight: 200;
        max-width: 800px;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.46;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        margin-top: 20px;

        > span {
          color: #5099de;
          text-decoration: none;
        }
      }
    }
  }

  > .payroll__breakdown--loader {
    > div {
      width: 55px;
      margin: auto;
    }
  }

  .payroll__breakdown--details {
    margin-bottom: 50px;
    padding: 0 20px;

    > .payroll__breakdown--details-header {
      overflow: hidden;
      padding-bottom: 15px;
      border-bottom: 5px solid #5099de;

      > .payroll__breakdown--details-header-name {
        width: 70%;
        float: left;
        display: flex;
        justify-content: center;
        flex-wrap: nowrap;

        > div {
          flex: 0 0 33.333333%;
          font-size: 1rem;
          font-weight: 500;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          padding-left: 10px;
          padding-top: 10px;
        }
      }

      > .payroll__breakdown--details-header-btn {
        width: calc(100% - 70%);
        max-width: 10.417vw;
        float: right;
        overflow: hidden;

        > div {
          height: 38px;
          border-radius: 2px;
          background-color: #5099de;
          font-size: 1rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.19;
          letter-spacing: normal;
          color: #ffffff;
          text-align: center;
          cursor: pointer;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
        }
      }
    }

    .payroll__breakdown--details-body {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      margin-bottom: 5px;
      // padding-bottom: 45px;

      > div {
        > .payroll__breakdown--details-body-header {
          overflow: hidden;
          padding-top: 15px;
          padding-bottom: 15px;

          > .payroll__breakdown--details-body-header-name {
            width: 70%;
            float: left;
            display: flex;
            justify-content: center;
            flex-wrap: nowrap;

            > div {
              flex: 0 0 33.333333%;
              font-size: 1rem;
              font-weight: 500;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
              padding-left: 10px;
              padding-right: 5px;
              padding-top: 10px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          > .payroll__breakdown--details-body-header-btn {
            width: calc(100% - 70%);
            float: right;
            overflow: hidden;
            overflow: hidden;

            > .payroll__breakdown--details-body-header-skip {
              width: 70%;
              float: left;
              font-size: 1rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.19;
              letter-spacing: normal;
              text-align: left;
              color: #de5050;
              padding-top: 12px;
              cursor: pointer;
            }
            > .payroll__breakdown--details-body-header-enable {
              width: 70%;
              float: left;
              font-size: 1rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.19;
              letter-spacing: normal;
              text-align: left;
              color: #5099de;
              padding-top: 12px;
              cursor: pointer;
            }

            > .payroll__breakdown--details-body-header-less {
              width: 30%;
              float: left;
              padding-top: 5px;
              color: #f17d6b;

              > div {
                width: 70%;
                height: 8px;
                background-color: #f17d6b;
                margin: auto;
              }

              > p {
                font-size: 2rem;
                font-weight: 300;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.31;
                letter-spacing: normal;
                text-align: left;
                color: #f17d6b;
                text-align: center;
                cursor: pointer;
              }
            }
          }
        }

        > .payroll__breakdown--details-body-container {
          > .payroll__breakdown--details-body-form {
            overflow: hidden;
            display: flex;
            flex-wrap: nowrap;
            justify-content: center;
            padding-bottom: 50px;
            text-align: left;

            > .payroll__breakdown--details-body-form-compensation {
              flex: 2 0 33.3333333333%;
              overflow: hidden;
              padding-left: 50px;

              > span {
                font-size: 1rem;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.19;
                letter-spacing: normal;
                text-align: left;
                color: #777777;
                text-decoration: underline;
              }

              > div {
                > div {
                  padding-top: 20px;
                  overflow: hidden;
                  > .payroll__breakdown--name {
                    width: 40%;
                    float: left;
                    font-size: 1rem;
                    font-weight: normal;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.19;
                    letter-spacing: normal;
                    text-align: left;
                    color: #707070;
                    padding-top: 7px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                  }

                  > .payroll__breakdown--input {
                    width: 40%;
                    float: left;
                    position: relative;

                    > input {
                      height: 30px;
                      border: solid 1px rgba(112, 112, 112, 0.5);
                      background-color: #ffffff;
                      outline: none;
                      padding-left: 25px;
                      font-size: 1rem;
                      font-weight: normal;
                      font-style: normal;
                      font-stretch: normal;
                      line-height: 1.19;
                      letter-spacing: normal;
                      text-align: left;
                      color: #707070;
                      padding-right: 5px;
                    }

                    > div {
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 20px;
                      height: 30px;
                      border: 1px solid rgba(112, 112, 112, 0.5);
                      text-align: center;
                      padding-top: 5px;
                      font-size: 1rem;
                      font-weight: normal;
                      font-style: normal;
                      font-stretch: normal;
                      line-height: 1.19;
                      letter-spacing: normal;
                      color: #707070;
                      display: flex;
                      flex-direction: row;
                      flex-wrap: nowrap;
                      align-items: center;
                      justify-content: center;
                      align-content: center;
                    }
                  }

                  > .payroll__breakdown--close {
                    width: 20%;
                    float: left;
                    text-align: center;
                    color: #f16b6f;
                    padding-top: 5px;
                    cursor: pointer;
                  }
                }
              }
            }

            > .payroll__breakdown--details-body-form-deductibles {
              flex: 2 0 33.3333333333%;
              overflow: hidden;
              padding-left: 50px;

              > span {
                font-size: 1rem;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.19;
                letter-spacing: normal;
                text-align: left;
                color: #777777;
                text-decoration: underline;
              }

              > div {
                > div {
                  padding-top: 20px;
                  overflow: hidden;
                  > .payroll__breakdown--name {
                    width: 40%;
                    float: left;
                    font-size: 1rem;
                    font-weight: normal;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.19;
                    letter-spacing: normal;
                    text-align: left;
                    color: #707070;
                    padding-top: 7px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                  }

                  > .payroll__breakdown--input {
                    width: 40%;
                    float: left;
                    position: relative;

                    > input {
                      height: 30px;
                      border: solid 1px rgba(112, 112, 112, 0.5);
                      background-color: #ffffff;
                      outline: none;
                      padding-left: 25px;
                      font-size: 1rem;
                      font-weight: normal;
                      font-style: normal;
                      font-stretch: normal;
                      line-height: 1.19;
                      letter-spacing: normal;
                      text-align: left;
                      color: #707070;
                      padding-right: 5px;
                    }

                    > div {
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 20px;
                      height: 30px;
                      border: 1px solid rgba(112, 112, 112, 0.5);
                      text-align: center;
                      font-size: 1rem;
                      font-weight: normal;
                      font-style: normal;
                      font-stretch: normal;
                      line-height: 1.19;
                      letter-spacing: normal;
                      color: #707070;
                      display: flex;
                      flex-direction: row;
                      flex-wrap: nowrap;
                      align-items: center;
                      justify-content: center;
                      align-content: center;
                    }
                  }

                  > .payroll__breakdown--close {
                    width: 20%;
                    float: left;
                    text-align: center;
                    color: #f16b6f;
                    padding-top: 5px;
                    cursor: pointer;
                  }
                }
              }
            }

            > .payroll__breakdown--details-body-form-payable {
              flex: 2 0 33.3333333333%;
              overflow: hidden;
              padding-left: 50px;

              > span {
                font-size: 1rem;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.19;
                letter-spacing: normal;
                text-align: left;
                color: #777777;
                text-decoration: underline;
              }

              > div {
                padding-top: 46px;
                > .payroll__breakdown--name {
                  width: 40%;
                  float: left;
                  font-size: 1rem;
                  font-weight: normal;
                  font-style: normal;
                  font-stretch: normal;
                  line-height: 1.19;
                  letter-spacing: normal;
                  text-align: left;
                  color: #707070;
                  padding-top: 7px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                }

                > .payroll__breakdown--input {
                  width: 40%;
                  float: left;
                  position: relative;

                  > input {
                    height: 30px;
                    border: solid 1px rgba(112, 112, 112, 0.5);
                    background-color: #ffffff;
                    outline: none;
                    padding-left: 25px;
                    font-size: 1rem;
                    font-weight: normal;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.19;
                    letter-spacing: normal;
                    text-align: left;
                    color: #707070;
                    padding-right: 5px;
                  }

                  > div {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 20px;
                    height: 30px;
                    border: 1px solid rgba(112, 112, 112, 0.5);
                    text-align: center;
                    font-size: 0.833vw;
                    font-weight: normal;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.19;
                    letter-spacing: normal;
                    color: #707070;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: center;
                    align-content: center;
                  }
                }

                > .payroll__breakdown--close {
                  width: 20%;
                  float: left;
                  text-align: center;
                  color: #f16b6f;
                  padding-top: 5px;
                }
              }
            }
          }

          > .payroll__breakdown--details-body-fields {
            > .payroll__breakdown--details-body-fields-more {
              max-width: 300px;
              margin: 0 auto;
              font-size: 1rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.19;
              letter-spacing: normal;
              text-align: center;
              color: #1ec4b4;
              cursor: pointer;
              padding-bottom: 50px;
            }

            .payroll__breakdown--details-body-fields-less {
              overflow: hidden;

              > p {
                font-size: 1rem;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.19;
                letter-spacing: normal;
                text-align: center;
                color: #1ec4b4;
                margin-bottom: 50px;
              }

              > div {
                width: 20.833vw;
                margin: 0 auto 20px auto;
                overflow: hidden;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-between;
                align-content: center;

                > .payroll__breakdown--details-body-fields-less-text {
                  width: 45%;
                  float: left;
                  font-size: 1rem;
                  font-weight: normal;
                  font-style: normal;
                  font-stretch: normal;
                  line-height: 1.19;
                  letter-spacing: normal;
                  text-align: left;
                  color: #777777;
                }

                > .payroll__breakdown--details-body-fields-less-select {
                  width: 45%;
                  float: right;
                  height: 30px;
                  border: solid 1px rgba(112, 112, 112, 0.5);
                  background-color: #ffffff;
                  overflow: hidden;

                  > select {
                    height: 30px;
                    background-color: #ffffff;
                    border: 0;
                    outline: 0;
                    font-size: 1rem;
                    font-weight: normal;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.19;
                    letter-spacing: normal;
                    text-align: left;
                    color: #777777;
                  }
                }

                > .payroll__breakdown--details-body-fields-less-input {
                  width: 45%;
                  float: left;
                  height: 30px;
                  border: solid 1px rgba(112, 112, 112, 0.5);
                  background-color: #ffffff;
                  overflow: hidden;

                  > input {
                    height: 30px;
                    background-color: #ffffff;
                    border: 0;
                    outline: 0;
                    font-size: 1rem;
                    font-weight: normal;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.19;
                    letter-spacing: normal;
                    text-align: left;
                    color: #777777;
                    padding: 0 5px;
                  }
                }

                > .payroll__breakdown--details-body-fields-less-amount {
                  width: 45%;
                  float: right;
                  height: 30px;
                  border: solid 1px rgba(112, 112, 112, 0.5);
                  background-color: #ffffff;
                  overflow: hidden;
                  position: relative;

                  > input {
                    height: 30px;
                    background-color: #ffffff;
                    border: 0;
                    outline: 0;
                    font-size: 1rem;
                    font-weight: normal;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.19;
                    letter-spacing: normal;
                    text-align: left;
                    color: #777777;
                    padding: 0 5px 0 25px;
                  }

                  > div {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 20px;
                    height: 30px;
                    text-align: center;
                    padding-top: 4px;
                    border-right: solid 1px rgba(112, 112, 112, 0.5);
                    background-color: #fbfafa;
                    color: #777777;
                  }
                }

                > .payroll__breakdown--details-body-fields-less-btn {
                  overflow: hidden;

                  > p {
                    text-align: center;
                    font-size: 1rem;
                    font-style: italic;
                    color: red;
                    height: 20px;
                    margin: 0;
                  }

                  > div {
                    width: 6.771vw;
                    height: 29.5px;
                    border-radius: 3px;
                    background-color: #5099de;
                    margin: auto;
                    font-size: 1rem;
                    font-weight: normal;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.21;
                    letter-spacing: normal;
                    text-align: center;
                    color: #ffffff;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: center;
                    align-content: center;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }
    }

    .payroll__breakdown--details-card {
      height: 67.5px;
      margin-top: 20px;
      margin-bottom: 22px;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding-top: 25px;

      .payroll__breakdown--details-card-name {
        flex: 2 0 30%;
        font-size: 1rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
      }
      .payroll__breakdown--details-card-gross {
        flex: 2 0 20%;
        font-size: 1rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
      }
      .payroll__breakdown--details-card-amount {
        flex: 2 0 20%;
        font-size: 1rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
      }
      .payroll__breakdown--details-card-skip {
        flex: 2 0 20%;
        font-size: 1rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.19;
        letter-spacing: normal;
        text-align: center;
        color: #5099de;
      }
      .payroll__breakdown--details-card-close {
        flex: 2 0 10%;
        color: #f16b6f;
        font-size: 1rem;
      }
    }
  }

  .payroll__breakdown--paginate {
    width: 300px;
    margin: 50px auto 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    align-content: center;
    border-radius: 4px;
    overflow: hidden;
    border-radius: 4px;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
    border: solid 1px #d7dae2;
    background-color: #ffffff;

    > div {
      width: 20%;
      padding: 8px 0;
      text-align: center;
      font-size: 1rem;
      color: #000000;
      border: solid 1px #d7dae2;
      background-color: #ffffff;
    }

    > div:nth-child(3) {
      color: #000000;
      background-color: #ddd;
    }
  }

  .payroll__breakdown--btns {
    p {
      text-align: center;
    }
    .payroll__breakdown--btnscover {
      margin: 0 auto;
      width: 50vw;
      display: flex;

      @media (max-width: 768px) {
        flex-direction: column;
      }
    }

    .f_button {
      width: full;
      padding: 1rem;
      margin: 0.5rem;
      background-color: #5099de;
      font-size: 0.833rem;
      color: #ffffff;
      cursor: pointer;
      border-radius: 4px;
      border: none;
    }

    .cancel {
       width: full;
      padding: 1rem;
      margin: 0.5rem;
      font-size: 0.833rem;
      cursor: pointer;
      border-radius: 4px;
      border: 1px solid #fff;
    }
  }
}
</style>
